import { Injectable } from '@angular/core';
import { Product } from '../Models/product';


@Injectable()
export class ProductDetailService {
  product: Product;
}



// WEBPACK FOOTER //
// ./src/app/Services/product.detail.ts